/**
 * Smatchy
 * The smatchy API description. Use POST /auth/login to get an access token.
 *
 * The version of the OpenAPI document: 1.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { GroupAncestorDto } from './groupAncestorDto';
import { PendingUserOfGroup } from './pendingUserOfGroup';
import { GeoLocationEntity } from './geoLocationEntity';
import { AdminUserOfGroup } from './adminUserOfGroup';
import { UserOfGroup } from './userOfGroup';
import { GroupSportDetail } from './groupSportDetail';

export interface GroupDetailsDto {
  _id: string;
  id: string;
  name: string;
  parentGroupId?: string;
  parentGroupName?: string;
  ancestors?: Array<GroupAncestorDto>;
  description: string;
  sport: GroupSportDetail;
  /**
   * SMA-99. Added by hand, not by the generator: `npm run generate:sdk` needs
   * the API running, because the Nest swagger plugin only writes this schema
   * during the webpack build. The offline export does not contain this model
   * at all, so regenerating from it would delete the file. Whoever next runs
   * the generator against a running API will simply produce this same line.
   */
  sports: GroupSportDetail[];
  nbUsers: number;
  location: GeoLocationEntity;
  privacy: GroupDetailsDto.PrivacyEnum;
  rightCreateActivity: GroupDetailsDto.RightCreateActivityEnum;
  backgroundUrl: string;
  /**
   * The group's own square mark, null when none was uploaded. Added by hand,
   * like the other fields the offline export does not carry.
   */
  logoUrl?: string | null;
  websiteUrl?: string;
  pendingInviteUsers: Array<PendingUserOfGroup>;
  owners: Array<AdminUserOfGroup>;
  members: Array<UserOfGroup>;
  admins: Array<string>;
  /**
   * SMA-185 Q7. Ids of the members named « Entraîneur » of the group. Added by
   * hand, like the fields above: the offline SDK export drops it, but the API
   * returns it (groups/domain/group-details.dto.ts). The mobile draws a badge
   * for each member listed here.
   */
  trainers: Array<string>;
  /**
   * SMA-185 Q7. True when the group OWNER is a validated pro — the one condition
   * that lets an administrator name a trainer. The mobile shows the « Nommer
   * entraîneur » action only when this is true, so it offers the action on
   * exactly the groups where the API will accept it. Hand-added for the same
   * reason as the fields above.
   */
  ownerIsPro: boolean;
  allowActivitySharing: boolean;
  handiFriendly?: boolean;
  isAdmin: boolean;
  isOwner: boolean;
  // Added by hand, like several fields above: the offline SDK export drops it,
  // but the API returns it (groups/domain/group-details.dto.ts). SMA-185 Q6: an
  // archived group is read-only, and the app needs to know to show it that way.
  isArchived: boolean;
  imAmPending: boolean;
  haveJoined: boolean;
  canPublish: boolean;
  subGroupCount?: number;
  totalMembersCount?: number;
  alreadyShared?: boolean;
}
export namespace GroupDetailsDto {
  export type PrivacyEnum = 'public' | 'private' | 'hidden';
  export const PrivacyEnum = {
    Public: 'public' as PrivacyEnum,
    Private: 'private' as PrivacyEnum,
    Hidden: 'hidden' as PrivacyEnum,
  };
  export type RightCreateActivityEnum = 'allMembers' | 'onlyAdmin';
  export const RightCreateActivityEnum = {
    AllMembers: 'allMembers' as RightCreateActivityEnum,
    OnlyAdmin: 'onlyAdmin' as RightCreateActivityEnum,
  };
}
